module.exports = __webpack_public_path__ + "static/shop-dd8d5f617d77ac79c6b49470d5ea9a62.webp";